import {FaChevronLeftIcon, FaChevronRightIcon, FaPhoneIcon} from './icons';

// Only the filled phone mirrors, matching the behaviour before the FontAwesome swap —
// the outline phone was never in this set.
export const DIRECTIONAL_GLYPHS: ReadonlySet<unknown> = new Set([FaChevronLeftIcon, FaChevronRightIcon, FaPhoneIcon]);
